import { proxy } from "valtio";
import { StockData, StockState } from "../types";

export const StockStore = proxy<StockState>({
  stockMap: {},
  updateStock: (stock: StockData[]) => {
    if (!stock?.length) {
      return;
    }
    const updatedStockMap = { ...StockStore.stockMap };
    stock.forEach((newStock) => {
      updatedStockMap[newStock.s] = newStock;
    });
    StockStore.stockMap = updatedStockMap;
    StockStore.updateTime = Date.now();
  },
  clearStockMap: function (): void {
    StockStore.stockMap = {};
    StockStore.updateTime = 0;
  },
  updateTime: 0,
});
